import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { R as RadioButtonLabel } from '../RadioButton/RadioButton-BaJZjGFF.js';
import { I as InputLabel } from '../../InputLabel/InputLabel-CXrYKIMY.js';
import { T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const FieldSet = /*#__PURE__*/styled.fieldset.withConfig({
  componentId: "sc-storm-ui-40025937__sc-3cfjbz-0"
})(["border:none;margin:0;padding:0;margin-block-start:unset;margin-block-end:unset;margin-inline-start:unset;margin-inline-end:unset;padding-inline-start:unset;"]);
const RadioButtonContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-3cfjbz-1"
})(["display:flex;flex-direction:", ";gap:", ";", ""], ({
  inline
}) => inline ? 'row' : 'column', ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["flex-direction:column;gap:0;border-radius:", ";border:", ";background:", ";overflow:hidden;& > *{width:100%;box-sizing:border-box;:not(:first-child){border-block-start:", ";}}& ", "{padding:", ";}"], ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  theme
}) => theme.border.subtle.default, RadioButtonLabel, ({
  theme
}) => theme.spacing.small.mobile)));
const StyledLegend = /*#__PURE__*/styled(InputLabel).withConfig({
  componentId: "sc-storm-ui-40025937__sc-3cfjbz-2"
})(["display:block;box-sizing:border-box;margin-block-end:", ";", ""], ({
  theme
}) => theme.controls.headerGap.default, isMobile(css(["margin-block-end:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const RadioGroupContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-3cfjbz-3"
})(["display:flex;flex-direction:", ";gap:", ";justify-content:flex-start;", ""], ({
  inlineLabel
}) => inlineLabel ? 'row' : 'column', ({
  inlineLabel,
  theme
}) => inlineLabel ? theme.controls.labelGap.default : theme.controls.headerGap, isMobile(css(["align-items:stretch;flex-direction:column;justify-content:flex-start;"])));
const RadioButtonGroup = ({
  children,
  inline = false,
  inlineLabel = false,
  label,
  disabled = false,
  hideLabel = false,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('radio-button-group')
}, /*#__PURE__*/React__default.createElement(FieldSet, rest, /*#__PURE__*/React__default.createElement(RadioGroupContainer, {
  inline: inline,
  inlineLabel: inlineLabel
}, label && /*#__PURE__*/React__default.createElement(StyledLegend, {
  disabled: disabled,
  hidden: hideLabel,
  renderAs: "legend"
}, label), /*#__PURE__*/React__default.createElement(RadioButtonContainer, {
  inline: inline
}, children))));

export { RadioButtonGroup as R };
//# sourceMappingURL=RadioButtonGroup-DL-JGoWZ.js.map
